/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef,useState } from 'react';
// import 'react-quill/dist/quill.snow.css'; // Import the Quill styles
import InputField from './Components/Fields/InputField';
import { debounce } from 'lodash';
import TextArea from './Components/Fields/TextArea';
import Paragraph from './Components/Fields/Paragraph';
import Radio from './Components/Fields/Radio';
import Table from './Components/Fields/Table';
import Image from './Components/Fields/Image';
import SelectBox from './Components/Fields/SelectBox';
import CheckBox from './Components/Fields/CheckBox';
import Line from './Components/Fields/Line';
import MainSignature from './Components/Fields/MainSignature';
import BarcodeGenerator from './Components/Fields/BarCode';
import TemplateComponent from './Components/Fields/TemplateComponent';
import AutoField from './Components/Fields/Autofield';

const DragableElement = ({ 
    view, 
    component, 
    index,
    droppedComponents,
    setDroppedComponents,
    pages,
    pageIndex,
    setPages,
    selectedComponent,
    onDrop,
    imageError,
    setImageError,
    formData,
    handleInitialFormData,
}) => {
    const containerRef = useRef(null);
    return (
        <>  
            {((!view || component?.show) &&  (component.page === pageIndex)) &&
            <div
                key={index}
                className={`absolute cursor-default ${component.type === 'container' ? 'transparent-container' : 'z-[1]'} ${component.type === 'container' ? 'border border-[#ccc] view-resize' : ''} ${(component.type === 'list') ? 'max-w-[720px]' : ''} ${component.type === 'table' ? 'max-w-[720px]' : ''}`}
                style={component.type === 'container' || (component.type === 'template' && component.is_template_selected) ?  {...component?.styles, left: component.x , top: component.y} : { width: component.line_type === 'Vertical' ? '' : component.width || 'auto', height: component.line_type === 'Vertical' ? component.width : component.type === 'paragraph' ? component.height : ''  || 'auto', left: component.x , top: component.y }}
                data-testid="component"
                data-componentid={component?.component_id}
                id={`main-${component?.component_id}`}
            >
                <div
                    style={(component.type === 'line' || component.type === 'paragraph') ? {height: '-webkit-fill-available', width: '-webkit-fill-available'} : {}}
                    className={`${(selectedComponent === index && component.type !== 'container') ? 'border-2 border-[#007EB4]' : ''} ${component.type === 'line' ? 'p-[10px]' : ''}`}>
                    {component?.type === 'input' && <InputField view={view} component={component} />}
                    {component?.type === 'textarea' && <TextArea view={view} component={component} />}
                    {component?.type === 'paragraph' && <Paragraph view={view} component={component} />}
                    {component?.type === 'radio' && <Radio component={component} view={view} />}
                    {component?.type === 'table' && <Table component={component} />}
                    {component?.type === 'image' && <Image imageError={imageError} setImageError={setImageError} view={view} component={component}/>}
                    {component?.type === 'container' && 
                    <div ref={containerRef} className={`w-[100px] h-[100px] cursor-default`} data-page-number={pageIndex} style={{
                        width: component?.styles?.width,
                        height: component?.styles?.height
                    }} onDrop={onDrop} data-testid="container" id={component.id} onMouseDown={(e) => (view) ? '' : handleDragStart(e)}/>}
                    {component?.type === 'select-box' && <SelectBox component={component} view={view}/>}
                    {component?.type === 'checkbox' && <CheckBox view={view} component={component} />}
                    {component?.type === 'line' && <Line component={component} view={view} />}
                    {component.type === 'signature' && <MainSignature formData={formData} handleInitialFormData={handleInitialFormData} component={component} selectedComponent={index} droppedComponents={droppedComponents} setDroppedComponents={setDroppedComponents} pages={pages} pageIndex={pageIndex} setPages={setPages} />}
                    {component?.type === 'barcode' && <BarcodeGenerator component={component} />}
                    {component?.type === 'template' && <TemplateComponent view={view} pageIndex={pageIndex} formData={formData} component={component} selectedComponent={index}  />}
                    {component?.type === 'autofield' && <AutoField view={view} component={component} />}
                </div>
            </div>
            }
        </>
    );
}

export default DragableElement;


